'use client';

import { c as _c } from "react/compiler-runtime";
import { CurrentUserFieldsFragment, Maybe } from 'api-graphql-types';
import { UserInfo, UserInfoLoading } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { useMemo } from 'react';
import TextLink from '../TextLink';
import LoginButton from './LoginButton';
import { RailsRoutes } from '@/helpers/utils';
const tracking_via = 'header_profile';
function SessionInfoContent(t0) {
  const $ = _c(60);
  const {
    user,
    loading
  } = t0;
  const t = useTranslations("nextjs");
  const locale = useLocale();
  let t1;
  bb0: {
    if (!user) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== locale || $[2] !== user.id) {
      t2 = RailsRoutes.userProfile({
        locale,
        id: user.id
      });
      $[1] = locale;
      $[2] = user.id;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t) {
      t3 = t("login.profile");
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
      t4 = {
        href: t2,
        name: t3
      };
      $[6] = t2;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== locale) {
      t5 = RailsRoutes.userDonationOverview({
        locale
      });
      $[9] = locale;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t) {
      t6 = t("login.donation_overview");
      $[11] = t;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== t5 || $[14] !== t6) {
      t7 = {
        href: t5,
        name: t6
      };
      $[13] = t5;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== locale || $[17] !== t || $[18] !== user.organisationId) {
      t8 = user.organisationId ? {
        href: RailsRoutes.organisationDashboard({
          locale,
          slug: user.organisationId
        }),
        name: t("login.organisation_dashboard")
      } : null;
      $[16] = locale;
      $[17] = t;
      $[18] = user.organisationId;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    let t9;
    if ($[20] !== locale) {
      t9 = RailsRoutes.startNewProject({
        locale,
        tracking_via
      });
      $[20] = locale;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] !== t) {
      t10 = t("login.new_project");
      $[22] = t;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    let t11;
    if ($[24] !== t10 || $[25] !== t9) {
      t11 = {
        href: t9,
        name: t10
      };
      $[24] = t10;
      $[25] = t9;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    let t12;
    if ($[27] !== locale) {
      t12 = RailsRoutes.startNewFunE({
        locale,
        tracking_via
      });
      $[27] = locale;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    let t13;
    if ($[29] !== t) {
      t13 = t("login.new_fundraising_event");
      $[29] = t;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    let t14;
    if ($[31] !== t12 || $[32] !== t13) {
      t14 = {
        href: t12,
        name: t13
      };
      $[31] = t12;
      $[32] = t13;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    let t15;
    if ($[34] !== locale) {
      t15 = RailsRoutes.signOut({
        locale
      });
      $[34] = locale;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    let t16;
    if ($[36] !== t) {
      t16 = t("login.log_out");
      $[36] = t;
      $[37] = t16;
    } else {
      t16 = $[37];
    }
    let t17;
    if ($[38] !== t15 || $[39] !== t16) {
      t17 = {
        href: t15,
        name: t16
      };
      $[38] = t15;
      $[39] = t16;
      $[40] = t17;
    } else {
      t17 = $[40];
    }
    let t18;
    if ($[41] !== t11 || $[42] !== t14 || $[43] !== t17 || $[44] !== t4 || $[45] !== t7 || $[46] !== t8) {
      t18 = [t4, t7, t8, t11, t14, "separator" as const, t17].filter(_temp);
      $[41] = t11;
      $[42] = t14;
      $[43] = t17;
      $[44] = t4;
      $[45] = t7;
      $[46] = t8;
      $[47] = t18;
    } else {
      t18 = $[47];
    }
    t1 = t18;
  }
  const links = t1;
  if (loading) {
    let t2;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <UserInfoLoading />;
      $[48] = t2;
    } else {
      t2 = $[48];
    }
    return t2;
  }
  if (!user) {
    let t2;
    if ($[49] !== t) {
      t2 = t("login.log_in");
      $[49] = t;
      $[50] = t2;
    } else {
      t2 = $[50];
    }
    let t3;
    if ($[51] !== t2) {
      t3 = <LoginButton>{t2}</LoginButton>;
      $[51] = t2;
      $[52] = t3;
    } else {
      t3 = $[52];
    }
    return t3;
  }
  const {
    avatar,
    fullName
  } = user;
  let t2;
  if ($[53] !== t) {
    t2 = t("login.my_profile");
    $[53] = t;
    $[54] = t2;
  } else {
    t2 = $[54];
  }
  let t3;
  if ($[55] !== avatar || $[56] !== fullName || $[57] !== links || $[58] !== t2) {
    t3 = <UserInfo Link={TextLink} text={{
      avatar,
      name: fullName,
      myProfile: t2,
      links
    }} />;
    $[55] = avatar;
    $[56] = fullName;
    $[57] = links;
    $[58] = t2;
    $[59] = t3;
  } else {
    t3 = $[59];
  }
  return t3;
}
function _temp(link) {
  return link !== null;
}
export default SessionInfoContent;